import React from 'react';

import get from 'lodash/get';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const ContactPersonSection = ({ data }) => (
  <DescriptionList data={data} disableGutters={true} stripEmpty={true}>
    <DescriptionItem
      label={'Name'}
      value={[
        get(data, 'contactPerson.firstName'),
        get(data, 'contactPerson.lastName'),
      ].join(' ')}
    />
    <DescriptionItem label={'Email'} field={'contactPerson.email'} />
    <DescriptionItem label={'Mobile'} field={'contactPerson.mobile'} />
    <DescriptionItem label={'Phone'} field={'contactPerson.phone'} />
    <DescriptionItem label={'Skype'} field={'contactPerson.skype'} />
  </DescriptionList>
);

export default ContactPersonSection;
